import {ApckPortletTable} from "../portlet";

export const ApckPortletScheduledScans = /*#__PURE__*/ ApckPortletTable.extend({
    props: {
        ctype: {
            type: String,
            default: "scheduledscansportlet"
        },
        title: {
            type: String,
            default: "Scheduled Scans"
        },
        size: {
            type: String,
            default: "md"
        },
        description: {
            type: String,
            default: "A quick access table of scheduled scans"
        },
        src: {
            type: String,
            default: "/scheduledscans"
        },
        limit: {
            type: Number,
            default: 100
        },
        showPageBar: {
            type: Boolean,
            default: true
        },
        sglRowAction: {
            type: Function,
            default: function (rec) {
                if (this.$globalFlags.spa) {
                    var res = {
                        name: 'scans.results',
                        params: {
                            scan_id: rec.get("_id")
                        }
                    };
                    return this.$router.push(res);
                } else {
                    window.open(`/scans/${rec.get('_id')}`, '_blank').focus();
                }
            },
        },
        cols: {
            type: Array,
            default: () => [
                {heading: "Name", data: "name", width: 90},
                {heading: "Scheduled Start", ctype: "datecolumn", data: "time", center: true, width: 150},
                {heading: "Rescan Interval", data: "repeat_interval", center: true, width: 120}
            ]
        },
    },
});
